module.exports = __webpack_public_path__ + "media/images/pattern-3464366412095afa4fffb16e95ed5a26.svg";